module.exports = __webpack_public_path__ + "static/img/dn1.0d0e40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn1.png
// module id = he3e
// module chunks = 0